import { useState, useEffect, useRef } from "react";

/**
 * Circular carousel window logic
 * Auto-scroll pauses on user interaction (hover / manual nav)
 */
export function useCarouselWindow({
  total,
  visible,
  auto = true,
  interval = 3000,
}) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const timerRef = useRef(null);

  /* ---------- AUTO SCROLL ---------- */
  useEffect(() => {
    if (!auto || paused) return;

    timerRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % total);
    }, interval);

    return () => clearInterval(timerRef.current);
  }, [auto, paused, interval, total]);

  /* ---------- CONTROLS ---------- */
  const next = () => {
    setPaused(true);
    setIndex((i) => (i + 1) % total);
  };

  const prev = () => {
    setPaused(true);
    setIndex((i) => (i - 1 + total) % total);
  };

  const pause = () => setPaused(true);
  const resume = () => setPaused(false);

  /* ---------- WINDOW ---------- */
  const window = [];
  for (let i = 0; i < visible; i++) {
    window.push((index + i) % total);
  }

  return {
    index,
    window,
    next,
    prev,
    pause,
    resume,
  };
}
